import usePaginatedData from './use-paginated-data';
import { transformOneFilterNotification } from 'api/transformers';
import { ApartmentListItemProps } from 'components/apartment-list-item';
import { APIFilterNotificationItem } from '../types';

export type APIApartmentNotificationRes = {
  items: APIFilterNotificationItem[];
  count: number;
};

export type ApartmentNotification = Omit<ApartmentListItemProps, 'className' | 'icon'> & {
  id: number;
  notification: { id: number; isEnabled: boolean };
  facilityId: number;
};

const useApartmentOneFilterNotification = (id: number) => {
  const result = usePaginatedData<APIApartmentNotificationRes, ApartmentNotification>(
    `/filter-notifications/${id}/search`,
    'post',
    // @ts-ignore
    ({ items, count }) => {
      const notifications = items.map(transformOneFilterNotification);

      return { items: notifications, count };
    },
    {},
  );

  return result;
};

export default useApartmentOneFilterNotification;
